import fetch from 'auth/FetchInterceptor'
import {API_BASE_URL} from '../configs/AppConfig'
const SportService = {}


SportService.getSport = function (params) {
	 
	 let offset = (params-1)*10;
	return fetch({
		url: API_BASE_URL+'/v1/admin/all-sport',
		method: 'get',
        params: {
            'offset' : offset
        }
	})
}; 

SportService.createSport = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/create-sport`,
		method: 'post',
        data: data
	})
};

SportService.updateSport = function (data) {
	return fetch({
		url: API_BASE_URL+`/v1/admin/edit-sport`,
		method: 'post',
        data: data
	})
};


export default SportService;